export default __webpack_public_path__ + "static/media/iitk-logo-with-text.93c803c1.png";